import { brand } from "config/brand"
import * as React from "react"
import * as styles from "./styles.module.scss"
import Document from "components/Document"
import Footer from "components/Footer"
import HeroCircle from "components/HeroCircle"
import Media from "components/Media"
import Navbar from "components/Navbar"
import { GetStartedType } from "components/Navbar/GetStartedButton"
import SideNav from "components/SideNav"
import TextImageBlock from "components/TextImageBlock"
import WorkBetter from "components/WorkBetter"
import betterEmployee02_1080w from "images/better-employee-02-1080w.jpg"
import betterEmployee02_540w from "images/better-employee-02-540w.jpg"
import betterEmployee03_1080w from "images/better-employee-03-1080w.jpg"
import betterEmployee03_540w from "images/better-employee-03-540w.jpg"
import betterEmployee04_1080w from "images/better-employee-04-1080w.jpg"
import betterEmployee04_540w from "images/better-employee-04-540w.jpg"
import betterFlag1080w_090718 from "images/better-flag-1080w-090718.jpg"
import betterFlag540w_090718 from "images/better-flag-540w-090718.jpg"
import PageWrapper, { PaddingTop } from "components/PageWrapper"
import SubNavbarAbout from "components/SubNavbarAbout"

const Careers: React.FC = () => {
  return (
    <Document
      title="About Us"
      description={`Meet the team behind ${brand.name}.`}
      pageId="CareersPage"
      pageClass="AboutUsPage"
    >
      <Navbar getStartedType={GetStartedType.ALWAYS} />
      <SubNavbarAbout />
      <SideNav />
      <PageWrapper paddingTop={PaddingTop.SubNavbar}>
        <main className={styles.careers}>
          <HeroCircle
            heading="Join our team"
            headingSize="lg"
            subhead="Be part of something Better."
            subheadSize="lg"
            imgSrcLarge={betterEmployee04_1080w}
            imgSrcLargeWidth="1080w"
            imgSrcSmall={betterEmployee04_540w}
            imgSrcSmallWidth="540w"
            imgAlt="Better employee working"
          />
          <TextImageBlock
            picturePosition="left"
            eyebrow="Who we are"
            heading="Better 101"
            subhead="We’re a 21st century mortgage lender. We’re part tech platform, part finance startup. We’ve corralled some of the best talent in the country. And we’re putting the mortgage industry on notice."
            cta="Open Roles"
            ctaLink="https://boards.greenhouse.io/better#.WSb_UBMrI6g"
            imgSrcLarge={betterEmployee02_1080w}
            imgSrcLargeWidth="1080w"
            imgSrcSmall={betterEmployee02_540w}
            imgSrcSmallWidth="540w"
            imgAlt="Better employee typing"
          />
          <TextImageBlock
            picturePosition="right"
            eyebrow="What we do"
            heading="The Better mission"
            subhead="Mortgages are opaque, intimidating, and essential. As a result, they’re the last bastion of shady practices and double-dealing in consumer finance. Our goal is to give every American the opportunity for homeownership—to do that, we’re reimagining mortgages from the ground up."
            imgSrcLarge={betterFlag1080w_090718}
            imgSrcLargeWidth="1080w"
            imgSrcSmall={betterFlag540w_090718}
            imgSrcSmallWidth="540w"
            imgAlt="Better Flag"
          />
          <WorkBetter />
          <TextImageBlock
            picturePosition="left"
            eyebrow="Do Better"
            heading="Better jobs"
            subhead={`We're always looking for top talent to join our New York, San Francisco, Irvine, and Gurgaon teams. Check out our open roles for more info.`}
            cta="Open Roles"
            ctaLink="https://boards.greenhouse.io/better#.WSb_UBMrI6g"
            imgSrcLarge={betterEmployee03_1080w}
            imgSrcLargeWidth="1080w"
            imgSrcSmall={betterEmployee03_540w}
            imgSrcSmallWidth="540w"
            imgAlt="Better employee on a couch"
          />
        </main>
        <Media />
        <Footer />
      </PageWrapper>
    </Document>
  )
}

export default Careers
